// src/utils/shareUtils.ts
import { Platform, Share as RNShare } from "react-native";

/**
 * Share payload options
 */
export type SharePayload = {
  title?: string | undefined;
  message?: string;
  url?: string;
};

export async function sharePayload(payload: SharePayload) {
  const { title, message, url } = payload;

  // Native (iOS / Android)
  if (Platform.OS !== "web") {
    try {
      const result = await RNShare.share(
        {
          title,
          message: url ? `${message ? message + "\n\n" : ""}${url}` : message,
          url,
        },
        {
          dialogTitle: title,
        }
      );
      return { platform: "native", result };
    } catch (err) {
      // Re-throw or return failure
      throw err;
    }
  }

  // Web
  try {
    // navigator.share is available on mobile Chrome, Safari (iOS 12.2+), etc.
    const nav: any = (window as any).navigator;
    if (nav && typeof nav.share === "function") {
      await nav.share({
        title,
        text: message,
        url,
      });
      return { platform: "web", usedWebShare: true };
    }

    // Fallback: copy to clipboard (if available) and notify user
    const combined = [message, url].filter(Boolean).join("\n\n");
    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
      await navigator.clipboard.writeText(combined);
      return { platform: "web", usedClipboard: true };
    }

    // Last resort: use document.execCommand (older browsers)
    const textarea = document.createElement("textarea");
    textarea.value = combined;
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand("copy");
      document.body.removeChild(textarea);
      return { platform: "web", usedClipboard: true };
    } catch (e) {
      document.body.removeChild(textarea);
      throw new Error("No sharing available and clipboard write failed.");
    }
  } catch (err) {
    throw err;
  }
}